export const convertToUppercase = (value) => {
    return (value || '').toUpperCase();
}

export const convertToLowercase = (value) => {
    return (value || '').toLowerCase();
}